<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="equipment-failure">
      <div class="equipment-failure-top">
        <p class="equipment-failure-top-title">故障处理</p>
        <img
          class="equipment-failure-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="equipment-failure-middle" :class="{ 'records-tab': activeTab === 'records' }">
        <el-tabs 
          v-model="activeTab" 
          class="failure-tabs"
          @tab-click="onTabClick"
        >
          <el-tab-pane 
            label="提交故障" 
            name="submit"
          >
            <submit-failure
              ref="submitFailure"
              :deviceData="deviceData"
              :hospitalList="hospitalList"
              @onSubmit="onSubmitFailure"
            />
          </el-tab-pane>
          
          <el-tab-pane 
            label="故障运维处理" 
            name="maintenance"
            v-if="shouldShowMaintenanceTabs"
          >
            <failure-maintenance
              v-if="visitedTabs.includes('maintenance')"
              ref="failureMaintenance"
              :deviceData="deviceData"
              @onSubmit="onSubmitMaintenance"
            />
          </el-tab-pane>
          
          <el-tab-pane 
            label="故障完毕" 
            name="complete"
            v-if="shouldShowMaintenanceTabs"
          >
            <failure-complete
              v-if="visitedTabs.includes('complete')"
              ref="failureComplete"
              :deviceData="deviceData"
              :hospitalList="hospitalList"
              @onSubmit="onSubmitComplete"
            />
          </el-tab-pane>
          
          <el-tab-pane 
            label="查看处理记录" 
            name="records"
          >
            <view-failure-records
              v-if="visitedTabs.includes('records')"
              :deviceData="deviceData"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="equipment-failure-bottom" v-if="activeTab !== 'records'">
        <button class="equipment-failure-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="equipment-failure-bottom-confirm" @click="onConfirmClick">提交</button>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import { Tabs, TabPane } from "element-ui";
import SubmitFailure from "./submit-failure.vue";
import FailureMaintenance from "./failure-maintenance.vue";
import FailureComplete from "./failure-complete.vue";
import ViewFailureRecords from "./view-failure-records.vue";

export default {
  components: {
    PopView,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    SubmitFailure,
    FailureMaintenance,
    FailureComplete,
    ViewFailureRecords,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      activeTab: "submit", // 默认显示"提交故障"
      visitedTabs: ["submit"], // 记录已访问的tab，默认包含submit
    };
  },

  computed: {
    shouldShowMaintenanceTabs() {
      return this.$store.getters.isSeniorAdministrator && this.deviceData.maintenanceOrderId;
    },
  },

  methods: {
    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    onConfirmClick: function () {
      // 根据当前激活的tab调用相应的提交方法
      if (this.activeTab === 'submit') {
        const submitComponent = this.$refs.submitFailure;
        if (submitComponent && typeof submitComponent.onSubmit === 'function') {
          submitComponent.onSubmit();
        } else {
          this.$toast.showRed("提交组件未找到");
        }
      } else if (this.activeTab === 'maintenance') {
        const maintenanceComponent = this.$refs.failureMaintenance;
        if (maintenanceComponent && typeof maintenanceComponent.onSubmit === 'function') {
          maintenanceComponent.onSubmit();
        }
      } else if (this.activeTab === 'complete') {
        const completeComponent = this.$refs.failureComplete;
        if (completeComponent && typeof completeComponent.onSubmit === 'function') {
          completeComponent.onSubmit();
        }
      } else if (this.activeTab === 'records') {
        this.$toast.showRed("当前页面无需提交操作");
      }
    },

    onTabClick: function (tab) {
      this.activeTab = tab.name;
      
      // 添加到已访问的tab列表中，实现懒加载
      if (!this.visitedTabs.includes(tab.name)) {
        this.visitedTabs.push(tab.name);
      }
    },

    onSubmitFailure: function (data) {
      console.log('onSubmitFailure',data);
      this.$emit("onSubmitFailure", data);
    },

    onSubmitMaintenance: function (data) {
      this.$emit("onSubmitMaintenance", data);
    },

    onSubmitComplete: function (data) {
      this.$emit("onSubmitComplete", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.equipment-failure {
  width: rem(700);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;

    .failure-tabs {
      ::v-deep .el-tabs__header {
        margin: 0 0 rem(20) 0;
      }

      ::v-deep .el-tabs__nav-wrap {
        padding: 0;
      }

      ::v-deep .el-tabs__item {
        padding: 0 rem(20);
        height: rem(40);
        line-height: rem(40);
        font-size: rem(14);
        color: rgba($color: black, $alpha: 0.65);

        &.is-active {
          color: #325FAC;
        }
      }

      ::v-deep .el-tabs__active-bar {
        background-color: #325FAC;
      }

      ::v-deep .el-tabs__content {
        padding: rem(20) 0;
      }
    }

    &.records-tab {
      margin-bottom: rem(60);
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>